export default __webpack_public_path__ + "static/reviews-32d7a2766bf77aa14dd96091944269a9.png";